import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { useState } from "react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setTimeout(() => {
      toast.success("Message received. The credentialing office will respond within 2 business days.");
      setForm({ name: "", email: "", subject: "", message: "" });
      setSending(false);
    }, 600);
  };

  return (
    <div data-testid="contact-page">
      <section className="border-b border-slate-200 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-3">Contact</div>
          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-primary tracking-tight">Contact ACIS &amp; IBTHM.</h1>
          <p className="mt-3 max-w-2xl text-slate-600">
            For credential inquiries, application support, complaints, and verification requests.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1 space-y-4">
            <Card className="p-5 border-slate-200" data-testid="contact-card-email">
              <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-md bg-primary/5 text-primary flex items-center justify-center">
                  <Mail className="h-5 w-5" strokeWidth={1.75} />
                </div>
                <div>
                  <a
                    href="mailto:join@aciscommission.com"
                    className="font-heading font-semibold text-primary text-sm hover:underline"
                    data-testid="contact-email-link"
                  >
                    join@aciscommission.com
                  </a>
                  <div className="text-xs text-slate-500 mt-1">Application support · Verifications · Complaints</div>
                </div>
              </div>
            </Card>
            <Card className="p-5 border-slate-200 bg-slate-50/60" data-testid="contact-info-box">
              <div className="text-xs text-slate-600 leading-relaxed">
                The email address above is the official channel for all correspondence at this time.
              </div>
            </Card>
          </div>

          <Card className="lg:col-span-2 p-7 border-slate-200">
            <h2 className="font-heading text-xl font-bold text-primary mb-1">Send a message</h2>
            <p className="text-sm text-slate-500 mb-6">All messages are logged and routed to the appropriate office.</p>
            <form onSubmit={onSubmit} className="grid sm:grid-cols-2 gap-4">
              <div>
                <Label className="mb-1.5 block">Name</Label>
                <Input data-testid="contact-name" required value={form.name} onChange={(e) => set("name", e.target.value)} />
              </div>
              <div>
                <Label className="mb-1.5 block">Email</Label>
                <Input data-testid="contact-email" type="email" required value={form.email} onChange={(e) => set("email", e.target.value)} />
              </div>
              <div className="sm:col-span-2">
                <Label className="mb-1.5 block">Subject</Label>
                <Input data-testid="contact-subject" required value={form.subject} onChange={(e) => set("subject", e.target.value)} />
              </div>
              <div className="sm:col-span-2">
                <Label className="mb-1.5 block">Message</Label>
                <Textarea data-testid="contact-message" rows={6} required value={form.message} onChange={(e) => set("message", e.target.value)} />
              </div>
              <div className="sm:col-span-2">
                <Button data-testid="contact-submit" disabled={sending} className="bg-primary text-white hover:bg-[#113A64]">
                  {sending ? "Sending…" : "Send message"}
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </section>
    </div>
  );
}
